import { Button, Form, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Select, SelectItem } from '@heroui/react'
import PhoneInput from 'components/Hero/PhoneInput'
import { useAuth } from 'hooks/useAuth'
import { Binoculars } from 'lucide-react'
import { useState } from 'react'

export default function ImpersonateModal({ isOpen, onOpenChange }) {
  const [resourceType, setResourceType] = useState('org_id')
  const [resourceId, setResourceId] = useState(null)
  const { impersonateUser } = useAuth()

  const onSubmit = async (e) => {
    e.preventDefault()
    await impersonateUser.mutateAsync({ resourceType, resourceId })
    onOpenChange(false)
  }

  const handleResourceTypeChange = (keys) => {
    setResourceId(null)
    setResourceType(Array.from(keys)[0])
  }

  return (
    <Modal
      isOpen={isOpen}
      placement="top-center"
      onOpenChange={onOpenChange}
      classNames={{
        footer: 'w-full border-t border-gray-200',
        body: 'flex flex-col gap-5 w-full',
        header: 'border-b border-gray-200 bg-[#18181b] w-full',
      }}
      radius="sm"
      size="xl"
    >
      <ModalContent>
        <Form validationBehavior="native" onSubmit={onSubmit}>
          <ModalHeader className="flex flex-col gap-1">
            <h2 className={`
              flex items-center gap-3 font-taurus text-2xl font-semibold
              text-white
            `}
            >
              <Binoculars size={20} />
              Impersonate User
            </h2>
            <p className={`
              font-taurus text-xs font-light tracking-wider text-foreground-400
            `}
            >
              Impersonate a user by their ID or phone number. If an organization ID is selected, the impersonated user will be the owner of the organization.
            </p>
          </ModalHeader>
          <ModalBody>
            <div className="flex gap-2">
              <Select
                aria-label="Resource type"
                radius="sm"
                variant="flat"
                selectedKey={[resourceType]}
                defaultSelectedKeys={['org_id']}
                onSelectionChange={handleResourceTypeChange}
                name="resource_type"
                className="w-48 shrink-0"
              >
                <SelectItem key="org_id">Organization ID</SelectItem>
                <SelectItem key="c_id">Call ID</SelectItem>
                <SelectItem key="pathway_id">Pathway ID</SelectItem>
                <SelectItem key="phone_number">Phone Number</SelectItem>
                <SelectItem key="user_id">User ID</SelectItem>
              </Select>
              {resourceType === 'phone_number'
                ? (
                    <PhoneInput
                      value={resourceId}
                      onChange={setResourceId}
                      radius="sm"
                      color="default"
                      className="grow"
                      name="resource_id"
                      placeholder="Enter phone number"
                    />
                  )
                : (
                    <Input
                      key={resourceType}
                      variant="bordered"
                      radius="sm"
                      placeholder="Enter ID"
                      value={resourceId}
                      onValueChange={setResourceId}
                    />
                  )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button isDisabled={!resourceId || resourceId?.length < 9} fullWidth radius="sm" color="default" type="submit" isLoading={impersonateUser.isPending}>
              Impersonate
            </Button>
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  )
}
